exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-activity{float:right;margin-right:10px}.newActivity{overflow:hidden}.newActivity .click-events .el-radio{display:block;width:200px}.newActivity .wxApp-from{margin-bottom:10px;margin-left:120px}.newActivity .wxApp-from .el-input{width:60%}.inline{display:inline-block;margin-right:20px;margin-bottom:15px}.btn-activity+.btn-activity{margin-left:0}.activityTitle{width:50%}.activitylimitCount{width:15%;display:inline-block}.activityType{width:50%}.qizhiDate{display:inline-block;width:100%}.activityContent{width:98%}.newActivity .right{position:relative;left:70px}.newActivity .time{display:inline-block;width:25%;margin-right:17px}.activityTitle_sel{width:20%}.activityTitle_sel,.limitCount{display:inline-block;margin-left:20px;margin-bottom:10px}.limitCount{width:15%}.mylab{color:#1f2d3d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-70a2a67a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/activity/newActivity.vue
// module id = 573
// module chunks = 0